import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { Roles } from 'src/shared/enums';
import { payrollPaths } from 'src/admin-app/payroll/payroll.routes.module';
import { jobsPaths } from 'src/admin-app/jobs/jobs.routes';
import { quotesPaths } from 'src/admin-app/quotes/quotes.routes';
import { invoicingPaths } from 'src/admin-app/invoicing/invoicing.routes';
import { personnelPaths } from 'src/admin-app/personnel/personnel.routes';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

const defaultRouteTree = new Map<string, string>([
	[Roles.FieldDirector, jobsPaths.root],
	[Roles.FieldManager, jobsPaths.root],
	[Roles.FieldSupport, quotesPaths.root],
	[Roles.Payroll, payrollPaths.root],
	[Roles.Billing, invoicingPaths.root],
	[Roles.Admin, jobsPaths.root],
	[Roles.HR, personnelPaths.root],
]);

@Injectable({
	providedIn: 'root',
})
export class DefaultRouteGuard implements CanActivate {
	constructor(
		private readonly router: Router,
		private readonly authService: AuthService
	) {}

	canActivate(): Observable<boolean> {
		return this.authService.isAuthenticated$.pipe(
			filter((val) => val),
			map((_) => this.authService.userRoles),
			map((roles) => {
				let result: boolean = true;
				for (let i = 0; i < roles.length; i++) {
					if (defaultRouteTree.has(roles[i])) {
						this.router.navigateByUrl(
							defaultRouteTree.get(roles[i])
						);
						result = false;
						break;
					}
				}
				return result;
			})
		);
	}
}
